import { CustomCollapseCard, Text } from '@src/components';
import { Radio } from 'antd';
import { useMediaQuery } from '@src/hooks/useMediaQuery';
import '@src/styles/draftOrder/draftType.scss';
import { useDispatch, useSelector } from 'react-redux';
import { setDraftType } from '@src/store/slice/draftOrderSlice';

const PaymentType = () => {
  const isMobil = useMediaQuery({ query: '(max-width: 768px)' });
  const dispatch = useDispatch();
  const { draftType } = useSelector((state) => state?.draftOrder);
  const { isSchool } = useSelector((state) => state?.auth);

  return (
    <CustomCollapseCard
      bodyCenter={!isMobil}
      cardTitle={<Text t="pleaseSelectDraftType" />}
      cardTitleAlign="center"
    >
      <Radio.Group
        id="ticketRestaurant-draftOrder-draftType-draft-type-radioGroup-input-content"
        onChange={(e) => dispatch(setDraftType(e.target.value))}
        value={draftType}
        className="draft-type-radio-input-content"
      >
        {!isSchool ? (
          <Radio
            id="ticketRestaurant-draftOrder-draftType-draft-type-radio-input-content1"
            value={1}
            className={draftType === 2 ? 'ant-radio-wrapper-unchecked' : null}
          >
            <div className="new-order-draft">
              <Text t="newOrderDrafts" />
            </div>
          </Radio>
        ) : null}
        <Radio
          id="ticketRestaurant-draftOrder-draftType-draft-type-radio-input-content2"
          value={2}
          className={draftType === 1 ? 'ant-radio-wrapper-unchecked' : null}
        >
          <div className="balance-upload-draft">
            <Text t="balanceLoadingDrafts" />
          </div>
        </Radio>
      </Radio.Group>
    </CustomCollapseCard>
  );
};

export default PaymentType;
